import React, { useCallback, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import {
  BoxStyle,
} from "../../constantVaribles/constatanvariable";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js"
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import dayjs from "dayjs";
import SriyanshCardHeader from "../../components/CardHeader";
import EncryptService from "../../service/EncryptionService";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import CustomDropdownMenu from "../../CustomComponant/DropDownMenu";
import TablewithSumFooter from "../../CustomComponant/TablewithSumFooter";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";



function BillReceiptEntry() {
  const navigate = useNavigate();
  const [poNumber, setpoNumber] = useState("");
  const [poItemName, setpoItemName] = useState("");
  const [poValue, setpoValue] = useState(0);
  const [poQuantity, setpoQuantity] = useState(0);
  const [poDate, setpoDate] = useState(Date);
  const [ConsigneeName, setConsigneeName] = useState("");
  const { state } = useLocation();
let indentId=state.indent_id;
  


    const [gemchecked, setgemChecked] = useState(false); // Default is false
    const [gemNumber, setGemNumber] = useState(null); 
    const [gemDate, setGemDate] = useState(null);


  
  const [suitabilityDate, setsuitabilityDate] = useState();

  
  const [suitableQty, setSuitableQuantity] = useState(0);
  const [billDate, setBillDate] = useState(null);
  const [billQuantity, setbillQuantity] = useState(0);
  const [billValue, setbillValue] = useState(0);
  const [reason, setReason] = useState("");
  const [BillReceiptDate, setBillReceiptDate] = useState(null);
  const [NodalBillReceiptDate, setNodalBillReceiptDate] = useState(null);
  const today = dayjs();


const[balItemQty,setbalItemQty]=useState(0);
const[balItemVal,setbalItemVal]=useState(0);


  const [billNumber, setbillNumber] = useState();
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [showRemark, setShowRemark] = useState(true);

  const [partPayList, setpartPayList] = useState([]);

  
  const handleQuantityChange = (value) => {
    setbillQuantity(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setbillValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleClose = () => {
    navigate("../billpendinglist", { replace: true });
  };

  const handleOptionChange = (event) => {
    const selvalue = event.target.value;
    setSelectedOption(event.target.value);

    // alert(selvalue);
    if (selvalue === "0") {
      setShowRemark(true);
      setReason("");
    } else {
      setShowRemark(false);
    }
    setErrors({ selerr: "" });
  };

  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

  //console.log(indentId);

  const InsertPOData = async (e) => {
    e.preventDefault();
    let formErrors = {};
   
    if (!billDate) {formErrors.errBillDate = "Invalid Bill Date";}
    if (!BillReceiptDate) {formErrors.errreceiptDate = "Invalid Bill Receipt Date";}
    if (!NodalBillReceiptDate) {formErrors.errnodalDate = "Invalid Nodal Push date Date";}

    if (!billNumber || billNumber.length === 0)
      formErrors.errBill = "Invalid Bill Number";

    if (parseFloat(billQuantity) > parseFloat(suitableQty))
      formErrors.qty = "Qty should be less or equel then Suitable Qty";

    if (parseFloat(billValue) > parseFloat(poValue))
      formErrors.val = "Value should be less or equel then PO Qty";

    if (!billQuantity || parseFloat(billQuantity) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (!billValue || parseFloat(billValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (selectedOption === "1") {
      if (reason.length === 0)
        formErrors.reasonerr = "Remark Should not be Blank";
    }

    if (selectedOption === "0") {
      setReason(" ");
    }

    if (selectedOption.length === 0) {
      formErrors.selerr = "Bill Receipt Type Not Selected";
    }
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const BillRecdt = new Date(BillReceiptDate);
      const BillReceiptDate1 =
        BillRecdt.getFullYear() +
        "/" +
        parseInt(BillRecdt.getMonth() + 1) +
        "/" +
        BillRecdt.getDate();

      const billdt = new Date(billDate);
      const billDate1 =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

        const nodaldt = new Date(NodalBillReceiptDate);
        const nodaldt1 =
        nodaldt.getFullYear() +
          "/" +
          parseInt(nodaldt.getMonth() + 1) +
          "/" +
          nodaldt.getDate();
  



      apiClient.post("/BillEntry", {
          vponumber: poNumber,
          vbillnumber: billNumber,
          vbilldate: billDate1,
          vbillitemQty: billQuantity,
          vbillitemValue: billValue,
          vpaymenttype: selectedOption + " ",
          vremark: reason,
          vbillreceiptdate: BillReceiptDate1,
          ventryuser: uname,
          vip: ip,
          vnodaldate:nodaldt1,
        })
        .then(function (response) {
          setError(response.data);
          navigate("../billpendinglist", { replace: true });
        })
        .catch(function (error) {
          if (error.response.data && error.response.data.code==='ER_DUP_ENTRY') {
          alert("Duplicate Bill Number for this PO Not Allowed");
       }
     });
    }
  };

  const getdata = async (e) => {
   if (!indentId || indentId.trim() === "") return; 
    apiClient.post("/poDetailsBillReceived", {
        uname: uname,
        indentNumber: String(indentId),
      })
      .then(function (response) {
        setpoNumber(response.data[0].poNumber);

        setgemChecked(response.data[0].gemtype);
        setGemNumber(response.data[0].gemno);
        setGemDate(response.data[0].gemdate);



        setpoDate(response.data[0].PODate);
        setConsigneeName(response.data[0].POConsignee);
        setpoItemName(response.data[0].POItemName);
        setpoQuantity(response.data[0].POQty);
        setpoValue(response.data[0].POValue);
        //     //setitemreceivedDate(response.data[0].ItemReceivedDate);
        setsuitabilityDate(response.data[0].SuitabilityDate);
        setSuitableQuantity(response.data[0].receivedQty);
          setbillQuantity(response.data[0].balanceqty);

          setbillValue(response.data[0].balanceValue);
          setbalItemQty(response.data[0].balanceqty)
          setbalItemVal(response.data[0].balanceValue)

      })
      .catch(function (error) {
        setError(error);
      });
  };

  useEffect(() => {
    getdata();
    getpartpaidPOdata();
  },[]);

  const getpartpaidPOdata = useCallback(async () => {
    if (!poNumber || poNumber.trim() === "") return; // Early return if indentNo is not available
    try {
      // console.log("PO " + poNumber)
      const response = await apiClient.post("/partPaymentList_by_PONumber", {
        ponumber: poNumber,
      });

      setpartPayList(response.data);

      //console.log(response.data);
    } catch (err) {}
  }, [poNumber]); // Include indentNo in the dependency array if getPOdata depends on it

  useEffect(() => {
    // Update state if roles change (in case roles are updated dynamically)
    getpartpaidPOdata();
  }, [poNumber,getpartpaidPOdata]);

  const headers = [
    ["PO Number", "PO date", "Consignee"],
    ["Item Name", "PO Qty", "PO Value"],
    [ "Suitable Item Qty","Last Suitability Date", "Bill Item Qty(Max)"],
    ["Bill Item val(max)","GeM Bill Number","GeM Bill Date"]
  ];
  
  const gemno=gemchecked?gemNumber:'';
  const gemdt=gemchecked?gemDate:'';


  const rows = [
    [poNumber, poDate, ConsigneeName],
    [poItemName, poQuantity, poValue],
    [suitableQty,suitabilityDate,balItemQty],
    [balItemVal,gemno,gemdt],
  ];

  const columns = [
    "billnumber",
    "billdate",
     "paymentDesription",
    "remark",
    "billreceiptdate",
    "billitemquantity",
    "billitemValue",
  ];

  const columnNames = [
    "Bill Number",
    "Bill Date",
     "Payment Type",
    "Payment Description",
    "Bill Receipt Date",
    "Bill Qty.",
    "Bill Value",
  ]; // keys from your data objects

  const menuoptions = [
    { value: "0", label: "Full Payment" },
    { value: "1", label: "Partial Payment" },
    { value: "2", label: "Final Payment of Partial Paid" },
  ];



  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
    <div>
      {/* <SriyanshCardHeader Title="Bill/Invoice Received Date" /> */}

      <Card className="Formcard">
        {error && (
          <ToasterAlerts
            type="info"
            title="Messasge"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
        )}
<div className="input-groupHeading">
Bill/Invoice Received Entry

            </div>
        <CardContent>

        <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span" variant="h6">PO Details</Typography>
        </AccordionSummary>
        <AccordionDetails>
        
            <ListHeaderTableComponent headers={headers} rows={rows} />
        
        </AccordionDetails>
      </Accordion>





          {/* <div className="p-4">
            <ListHeaderTableComponent headers={headers} rows={rows} />
          </div> 
          style={BoxStyle}
          
          */}

          <div className="row p-2" >
            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="Bill/Invoice Date"
                  id="billdate"
                  value={billDate}
                 
                 //onChange={setBillDate}
                 
                  onChange={(newDate) =>
                    handleDateChange(newDate, setBillDate)
                  } 
                 
                  error={errors.errBillDate}
                 
                  maxDate={today}

                  


                 //minDate={poDate?dayjs(poDate):dayjs()}
                minDate={gemchecked ? dayjs(gemDate) : dayjs(poDate)}
                 // minDate={minCalDate}
                />
              </div>

              <div className="input-group mt-2">
                <CustomTextField
                  label="Bill/Invoice Number"
                  value={billNumber??''}
                  onChange={(e) => {
                    setbillNumber(e.target.value);
                  }}
                  placeholder="Bill/Invoice Number"
                  maxLength={50} // Set the maximum length
                  error={!!errors.errBill}
                  helperText={errors.errBill}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <NumericTextField
                  id="ItemQuantity"
                  label="Quantity"
                  title="Quantity"
                  error={errors.qty}
                  value={billQuantity??'0'}
                  onChange={handleQuantityChange}
                />
              </div>

              <div className="input-group">
                <NumericTextField
                  id="ItemValue"
                  label="Item Value"
                  title="Item Value"
                  error={errors.val}
                  value={billValue??'0'}
                  onChange={handleValueChange}
                />
              </div>
            </div>

            <div className="container">
              <div className="input-group">
                <DatePickerComponent
                  label="Bill/Invoice Receiving  Date"
                  id="BillReceiptDate"
                  value={BillReceiptDate}
                                 
                    onChange={(newDate) =>
                    handleDateChange(newDate, setBillReceiptDate)
                  } 
                  error={errors.errreceiptDate}
                  maxDate={today}
                 // minDate={billDate?dayjs(billDate):dayjs()}
                  //minDate={minCalDate}
                />
              </div>

              <div className="input-group mt-2">
                <CustomDropdownMenu
                  options={menuoptions}
                  selectedOption={selectedOption}
                  handleOptionChange={handleOptionChange}
                  error={error}
                  menulabel="Select Payment Option"
                />
              </div>



              <div className="input-group">
                <DatePickerComponent
                  label="Bill Submited to Nodal Section Date"
                  id="NodalSubmitBillDate"
                  value={NodalBillReceiptDate}
                    onChange={(newDate) =>
                    handleDateChange(newDate, setNodalBillReceiptDate)
                  } 
                error={errors.errnodalDate}
                  
                  maxDate={today}
                 // minDate={billDate?dayjs(billDate):dayjs()}
                  //minDate={minCalDate}
                />
              </div>


            </div>

            {/* here */}

            {!showRemark && (
              <div className="input-group">
                <CustomTextField
                  label="Reason Why ---> Partial Payment done "
                  value={reason??''}
                  onChange={(e) => {
                    setReason(e.target.value);
                  }}
                  placeholder="Reason"
                  maxLength={100} // Set the maximum length
                  error={!!errors.reasonerr}
                  helperText={errors.reasonerr}
                />
              </div>
            )}
          </div>

          {/* ============================================LIST of ALL PO ===========================================*/}

           {partPayList.length > 0 && (
            <TablewithSumFooter
              columns={columns}
              columnNames={columnNames}
              data={partPayList}
            />
          )}

          {/*=========================== END OF LIST ==========================================================*/}

          <>
            <div
              className="flex container"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertPOData}
                title="Click for Data Save"
              >
                Save Data
              </button>


            



              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
        </CardContent>
      </Card>
    </div>
  );
}

export default BillReceiptEntry;
